'use client';

import { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

const BACKDROP_ROTATION_INTERVAL_MS = 12500;

export default function HubMeetupDetailBackdrop({ images = [] }) {
  const reduceMotion = useReducedMotion();
  const safeImages = Array.isArray(images)
    ? Array.from(new Set(images.filter(Boolean)))
    : [];
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [safeImages.length]);

  useEffect(() => {
    if (reduceMotion || safeImages.length < 2) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveIndex((currentIndex) =>
        currentIndex + 1 >= safeImages.length ? 0 : currentIndex + 1,
      );
    }, BACKDROP_ROTATION_INTERVAL_MS);

    return () => window.clearInterval(intervalId);
  }, [reduceMotion, safeImages.length]);

  if (!safeImages.length) {
    return null;
  }

  return (
    <div className="hub-meetup-detail-backdrop" aria-hidden="true">
      {safeImages.map((image, index) => (
        <div
          key={`${image}-${index}`}
          className={`hub-meetup-detail-backdrop__layer${index === activeIndex ? ' is-active' : ''}`}
          style={{ backgroundImage: `url(${image})` }}
        />
      ))}
      <div className="hub-meetup-detail-backdrop__overlay" />
    </div>
  );
}